import { useQuery } from '@tanstack/react-query';

import { useRequest, queryClient, type QueryFunction } from '@frontend/api';

import type { Rule } from './types';

export const getUseRulesJsonDownloadKey = () => ['rules', 'json_download'];

export const useRulesJsonDownload: QueryFunction<
  Rule[],
  [],
  ReturnType<typeof getUseRulesJsonDownloadKey>
> = ({ queryOptions, requestOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey: getUseRulesJsonDownloadKey(),
    queryFn: ({ signal }) => {
      return request<Rule[]>(`/rules/json_download/`, {
        init: {
          signal,
          headers: {
            Accept: 'application/json',
          },
        },
        shouldConvertResponseKeysToCamelCase: false,
      });
    },
  });
};

export const invalidateRulesJSONDownloadQuery = () => {
  queryClient.invalidateQueries({ queryKey: getUseRulesJsonDownloadKey() });
};
